import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText, Divider } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

export const WITHOUT_QUEUE_VALUE = "__WITHOUT_QUEUE__";
const ALL_QUEUES_VALUE = "__ALL__";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
  },
  queueSelectContainer: {
    minWidth: 120,
    maxWidth: 200,
    width: "100%",
    marginTop: -4,
    [theme.breakpoints.down("sm")]: {
      minWidth: 100,
      maxWidth: 150,
    },
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
  hideWithoutQueue = false,
}) => {
  const classes = useStyles();

  const queueIds = (userQueues || []).map(queue => queue.id);
  const allValues = hideWithoutQueue ? [...queueIds] : [WITHOUT_QUEUE_VALUE, ...queueIds];

  const hasWithoutQueue = !hideWithoutQueue && selectedQueueIds.includes(WITHOUT_QUEUE_VALUE);
  const allQueuesSelected = queueIds.every(id => selectedQueueIds.includes(id));
  const allSelected = hideWithoutQueue ? allQueuesSelected : hasWithoutQueue && allQueuesSelected;

  const normalizeValues = (values) => {
    const cleanValues = values
      .filter(value => value !== ALL_QUEUES_VALUE)
      .filter(value => !hideWithoutQueue || value !== WITHOUT_QUEUE_VALUE);
    return Array.from(new Set(cleanValues));
  };

  const handleChange = (e) => {
    const values = e.target.value;

    if (values.includes(ALL_QUEUES_VALUE)) {
      onChange(allSelected ? [] : allValues);
      return;
    }

    const normalizedValues = normalizeValues(values);
    const normalizedAllSelected =
      normalizedValues.includes(WITHOUT_QUEUE_VALUE) &&
      queueIds.every(id => normalizedValues.includes(id));

    onChange(normalizedAllSelected ? allValues : normalizedValues);
  };

  return (
    <div className={classes.queueSelectContainer}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedQueueIds}
          onChange={handleChange}
          style={{
            borderRadius: 8,
            height: 30,
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: "0 0 8px 8px",
              },
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
        >
          <MenuItem dense value={ALL_QUEUES_VALUE} className={classes.menuItem}>
            <Checkbox size="small" color="primary" checked={allSelected} />
            <ListItemText primary="Todos" />
          </MenuItem>

          {!hideWithoutQueue && (
            <MenuItem dense value={WITHOUT_QUEUE_VALUE} className={classes.menuItem}>
              <Checkbox size="small" color="primary" checked={hasWithoutQueue} />
              <ListItemText primary="Sem Fila" />
            </MenuItem>
          )}

          <Divider />

          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem
                dense
                key={queue.id}
                value={queue.id}
                className={classes.menuItem}
              >
                <Checkbox
                  style={{
                    color: queue.color,
                  }}
                  size="small"
                  color="primary"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <ListItemText primary={queue.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;
